import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Proof() {
  return <section className="py-20 bg-tactical-dark border-b border-tactical-border" data-id="element-216">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-217">
        <FadeIn data-id="element-218">
          <div className="bg-gradient-to-br from-tactical-panel to-zinc-950 border border-zinc-800 p-8 sm:p-12 relative overflow-hidden" data-id="element-219">
            {/* Accent line */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-tactical-accent to-blue-600" data-id="element-220"></div>

            <div className="flex flex-col sm:flex-row gap-8 items-center sm:items-start" data-id="element-221">
              <div className="shrink-0" data-id="element-222">
                <div className="w-20 h-20 bg-tactical-accent/10 rounded-full flex items-center justify-center border border-tactical-accent/30" data-id="element-223">
                  <ShieldCheck className="w-10 h-10 text-tactical-accent" data-id="element-224" />
                </div>
              </div>

              <div data-id="element-225">
                <h2 className="text-3xl font-bold uppercase mb-4" data-id="element-226">
                  Lo que cambia en{' '}
                  <span className="text-tactical-accent" data-id="element-227">7 días</span>
                </h2>
                <div className="space-y-4 text-lg text-zinc-300" data-id="element-228">
                  <p data-id="element-229">
                    Tu mente dejará de preguntarse{' '}
                    <span className="text-zinc-100 font-mono bg-zinc-800 px-2 py-0.5" data-id="element-230">
                      "si"
                    </span>{' '}
                    debe hacer algo y empezará a preguntar{' '}
                    <span className="text-tactical-accent font-mono bg-tactical-accent/10 px-2 py-0.5 border border-tactical-accent/30" data-id="element-231">
                      "cuándo"
                    </span>
                    .
                  </p>
                  <p data-id="element-232">
                    La niebla mental desaparece, el ahorro se vuelve automático
                    y la sensación de control sobre tu destino se convierte en
                    tu nueva realidad diaria.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}